import StoredLayout from '../../layouts/StoredLayout'
import Pagination from './Pagination'
export default StoredLayout(Pagination)
